/**
 * Helper to draw midpoint.
 */
export const midpointLinePlugin = (color: string) => ({
  id: 'midpointLine',
  beforeDraw(chart: { ctx: any; chartArea: { left: any; top: any; width: any; height: any } }, args: any, options: any) {
    const { ctx, chartArea: { left, top, width, height } } = chart
    ctx.save()
    ctx.strokeStyle = color
    ctx.lineWidth = 1
    ctx.strokeRect(left + width * 0.5, top, 0, height)
    ctx.restore()
  }
})
